module.exports = __webpack_public_path__ + "assets/38e2ab0443e99c3d5938dd82b3d3f893.png";